export default function Navbar(){
    return(
        <nav id="nav" className="navbar navbar-expand-lg sticky-top bg-white shadow-sm">
            <div className="container">
                <a className="navbar-brand" href="/">MoQuayson</a>

                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <a className="nav-link" href='#expertise'>
                                Expertise
                            </a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link" href='#projects'>
                                Works
                            </a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link" href='#contact'>
                                Contact
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}